// extracted by mini-css-extract-plugin
export default {"team":"team_team__-n8Bu","teamMemberInfo":"team_teamMemberInfo__NMeFX","left":"team_left__RRj0D","right":"team_right__oO0qP","title":"team_title__qJCbf","desc":"team_desc__StwBE"};